import PropTypes from 'prop-types';
import React from 'react';
import api from '../../../Api';
import { connectToUser } from '../../User/containers/UserDataStore';
import makeConnectTo from '../../util/makeConnectTo';
import PreferenceType from '../PreferenceType';

const PreferencesContext = React.createContext();

const name = 'preferencesDataStore';

export const usePreferences = () => React.useContext(PreferencesContext);

export const connectToPreferences = makeConnectTo(PreferencesContext, name);

class PreferencesDataStore extends React.Component {
	static propTypes = {
		children: PropTypes.oneOfType([PropTypes.element, PropTypes.func]),
	};

	state = {
		preferences: [],
		isLoading: true,
	};

	render() {
		const preferencesDataStore = this.getStore();
		return (
			<PreferencesContext.Provider value={preferencesDataStore}>
				{typeof this.props.children === 'function'
					? this.props.children(preferencesDataStore)
					: this.props.children}
			</PreferencesContext.Provider>
		);
	}

	componentDidMount() {
		const { isAnonymous } = this.props.userDataStore;
		if (!isAnonymous()) {
			this.fetchPreferences();
		} else {
			this.setState({ isLoading: false });
		}
	}

	componentWillUnmount() {
		if (this.preferencesFetch && this.preferencesFetch.cancel) {
			this.preferencesFetch.cancel();
		}
	}

	getStore = (state = this.state) => ({
		state,
		refresh: () => this.refreshPreferences(),
		addUserPreference: (type, name, value, toggleIsLoading) =>
			this.addUserPreference(type, name, value, toggleIsLoading),
		addUserPreferenceWithPromise: (type, name, value) =>
			this.addUserPreferenceWithPromise(type, name, value),
		getPreference: (type, name) => this.getPreference(type, name),
	});

	refreshPreferences = () => {
		this.setState({
			isLoading: true,
		});
		this.fetchPreferences();
		return this.preferencesFetch.promise;
	};

	fetchPreferences = () => {
		var userPreferenceDtoFilters = [
			{
				type: PreferenceType.communityApp,
			},
			{
				type: PreferenceType.landingPage,
			},
		];

		const request = api.cancelablePost(
			`/api/v1/me/preferences`,
			userPreferenceDtoFilters,
		);
		request.promise.then(this.cacheApiResponse);
		this.preferencesFetch = request;
	};

	cacheApiResponse = apiResponse => {
		const preferences = apiResponse;
		this.setState({ preferences, isLoading: false });
	};

	addUserPreference(type, name, value, toggleIsLoading) {
		const { isAnonymous } = this.props.userDataStore;
		!isAnonymous() &&
			this.addUserPreferenceWithPromise(type, name, value).then(() => {
				if (toggleIsLoading) {
					this.refreshPreferences();
				} else {
					this.fetchPreferences();
				}
			});
	}

	addUserPreferenceWithPromise(type, name, value) {
		return api.put(`/api/v1/me/preferences/${type}/${name}`, value);
	}

	getPreference(type, name) {
		const { preferences } = this.state;

		return (
			preferences &&
			preferences.find(p => p.type === type && p.name === name)
		);
	}
}

export default connectToUser(PreferencesDataStore);
